import './App.scss';
import TouchSlider from './TouchSlider';

function App() {
  return (
    <div className="App">
      <div className="container">
        <div className="header">
          <h1>React Touch Slider Demo</h1>
        </div>
        <TouchSlider
          key="touch"
          loop={true}
          showNav={true}
          showArrows={true}>
          <div
            key="slide1" 
            className="slide slide-1">
            <div>
              <span>1</span>
            </div>
          </div>
          <div 
            key="slide2"
            className="slide slide-2">
            <div>
              <span>2</span>
            </div>
          </div>
          <div 
            key="slide3"
            className="slide slide-3">
            <div>
              <span>3</span>
            </div>
          </div>
          <div 
            key="slide4"
            className="slide slide-4">
            <div>
              <span>4</span>
            </div>
          </div>
          <div 
            key="slide5"
            className="slide slide-5">
            <div>
              <span>5</span>
            </div>
          </div>
        </TouchSlider>
        <div className="footer">
          <a href="https://github.com/japick/react-touch-slider" target="_blank">Github</a>
        </div>
      </div>
    </div>
  );
}

export default App;
